import React from "react";

const EditPencil: React.FC = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.19063 20.2499H5C4.80109 20.2499 4.61033 20.1709 4.46967 20.0302C4.32902 19.8896 4.25 19.6988 4.25 19.4999V15.3093C4.24966 15.2119 4.26853 15.1154 4.30553 15.0253C4.34253 14.9352 4.39694 14.8533 4.46563 14.7843L15.7156 3.53429C15.7854 3.46343 15.8686 3.40715 15.9603 3.36874C16.0521 3.33033 16.1505 3.31055 16.25 3.31055C16.3495 3.31055 16.4479 3.33033 16.5397 3.36874C16.6314 3.40715 16.7146 3.46343 16.7844 3.53429L20.9656 7.71554C21.0365 7.78533 21.0928 7.86851 21.1312 7.96026C21.1696 8.052 21.1894 8.15046 21.1894 8.24992C21.1894 8.34938 21.1696 8.44784 21.1312 8.53958C21.0928 8.63132 21.0365 8.71451 20.9656 8.78429L9.71563 20.0343C9.6466 20.103 9.56469 20.1574 9.4746 20.1944C9.38452 20.2314 9.28802 20.2503 9.19063 20.2499V20.2499Z"
          stroke="#98A2B3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.25 6L18.5 11.25"
          stroke="#98A2B3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
};

export default EditPencil;
